"use strict";
/* tslint:disable */
var load_themed_styles_1 = require('@microsoft/load-themed-styles');
load_themed_styles_1.loadStyles([{ "rawString": ".ms-groupFooter{position:relative;padding:10px 84px;cursor:pointer}.ms-groupFooter .ms-Link{font-family:\"Segoe UI WestEuropean\",\"Segoe UI\",-apple-system,BlinkMacSystemFont,Roboto,\"Helvetica Neue\",sans-serif;-webkit-font-smoothing:antialiased;font-size:12px}" }]);
/* tslint:enable */

//# sourceMappingURL=GroupFooter.scss.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/GroupedList/GroupFooter.scss.js
 ** module id = 135
 ** module chunks = 0
 **/